export const ACTIVITI = {
  search: "ค้นหา",
  get: "เปิดข้อมูล",
  create: "สร้าง",
  update: "อัพเดต",
  delete: "ลบ",
};
